import { render, staticRenderFns } from "./select-lens-cover.vue?vue&type=template&id=f172e45c&scoped=true"
import script from "./select-lens-cover.vue?vue&type=script&lang=js"
export * from "./select-lens-cover.vue?vue&type=script&lang=js"
import style0 from "./select-lens-cover.vue?vue&type=style&index=0&id=f172e45c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f172e45c",
  null
  
)

export default component.exports